import { Link, useLocation } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import { useSeo } from '@/hooks/useSeo';

export default function NotFound() {
  const location = useLocation();

  useSeo({
    title: '页面不存在 - 404｜爆料网上',
    description: '你访问的页面不存在或已调整地址，可以返回首页继续浏览爆料平台导航与论坛社区汇总。',
    keywords: '404,页面不存在,爆料网上',
    path: location.pathname,
  });

  const suggestions = [
    { label: '平台导航大全', to: '/directory', icon: 'ri-links-line' },
    { label: '论坛社区汇总', to: '/forums', icon: 'ri-chat-smile-2-line' },
    { label: '发布指南', to: '/guide', icon: 'ri-book-open-line' },
    { label: '关于我们', to: '/about', icon: 'ri-information-line' },
  ];

  return (
    <SiteLayout>
      <div className="mx-auto flex max-w-content flex-col items-center px-4 py-20 text-center md:px-6 md:py-28">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-accent-100 text-accent-700">
          <i className="ri-compass-3-line text-3xl"></i>
        </span>
        <p className="mt-6 font-heading text-5xl font-bold text-background-300">404</p>
        <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          这个页面走丢了
        </h1>
        <p className="mt-4 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
          你访问的地址可能输入有误，或者该页面已经调整。不妨从下面几个入口重新开始。
        </p>
        <p className="mt-2 max-w-xl break-all text-xs text-foreground-400">{location.pathname}</p>

        <div className="mt-8 grid w-full max-w-2xl grid-cols-1 gap-3 sm:grid-cols-2">
          {suggestions.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className="flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 px-4 py-3.5 text-left transition-colors hover:border-primary-300 cursor-pointer"
            >
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-100 text-primary-600">
                <i className={item.icon}></i>
              </span>
              <span className="whitespace-nowrap text-sm font-medium text-foreground-800">{item.label}</span>
              <i className="ri-arrow-right-line ml-auto text-foreground-400"></i>
            </Link>
          ))}
        </div>

        <Link
          to="/"
          className="mt-8 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
        >
          <i className="ri-home-4-line"></i>返回首页
        </Link>
      </div>
    </SiteLayout>
  );
}